module.exports = __webpack_public_path__ + "img/hr-cliff-entrance-shadow.d225360a.png";